
import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/avatar.svg";
import Tilt from "react-parallax-tilt";


import Nav from "react-bootstrap/Nav";

import { Link } from "react-router-dom";

function Home2() {

    return (
        <Container fluid className="home-about-section" id="about">
            <Container>
                <Row>
                    <Col md={8} className="home-about-description">
                        <h1 style={{ fontSize: "2.6em" }}>
                            ABOUT <span className="purple"> ME</span>
                        </h1>
                        <p className="home-about-body">

As a seasoned Data Engineer, my expertise spans across architecting, managing, and refining modern data infrastructures using engineering best practices. 
My experience extends to the creation and maintenance of both stream and batch data ingestion/integration pipelines, coupled with comprehensive data transformations and modeling.
<br />
<br />
I am dedicated to applying my solution-oriented approach and diligence to making valuable contributions to future data projects.
                        
                            <br />
                            <br />
                        
                            <Nav.Link
                                as={Link}
                                to="/about"
                                className="purple"
                                >
                                Check out my skills
                                </Nav.Link>        


                            <Nav.Link
                                as={Link}
                                to="/project"
                                className="purple"
              
                            >
                             Check out my projects
                            </Nav.Link>

                            <Nav.Link
                                as={Link}
                                to="/resume"
                                className="purple"
                                >
                                Check out my resume
                                </Nav.Link>


                        </p>
                    </Col>
                    <Col md={4} className="myAvtar">
                        <Tilt>
                            <img src={myImg} className="img-fluid" alt="avatar" />
                        </Tilt>
                    </Col>
                </Row>
                
            </Container>
        </Container>
    );
}
export default Home2;
